import { saveAs } from 'file-saver';

import { FORM_STATUS } from '../types/form-status';
import { Insurance } from '../types/insurance';
import { MultisectActionDto } from '../types/multiselect-action-dto';
import { PaginatedResponse } from '../types/paginated';
import { Filters, formatFilters } from '../utils/format-filters';
import { handleRequest } from '../utils/handle-request';

import { privateClient } from './api-client';

export const insuranceApi = {
  getAll: ({ filters }: { filters: Filters }) => {
    return privateClient
      .get('nitrogen/insurance/', {
        searchParams: {
          ...formatFilters(filters),
        },
      })
      .json<PaginatedResponse<Insurance>>();
  },

  // synthesis
  exportSynthesis: async (data: MultisectActionDto) => {
    const res = await handleRequest<{
      id: 89;
      status: FORM_STATUS;
      instance_id: 89;
    }>(
      privateClient
        .post(`nitrogen/insurance/prep_synthesis/`, {
          json: data,
        })
        .json(),
    );

    return res;
  },
  downloadExport: async (opts: { id: number }) => {
    const res = await handleRequest(
      privateClient.post(`nitrogen/insurance/synthesis/`, {
        json: {
          instance_id: opts.id,
        },
      }),
    );

    // Extract filename from header
    const filename = res.headers
      .get('content-disposition')
      ?.split(';')
      .find((n) => n.includes('filename='))
      ?.replace('filename=', '')
      .trim();

    const blob = await res.blob();

    saveAs(blob, filename);

    return res;
  },
};
